// extracted by mini-css-extract-plugin
module.exports = {"navbarCollapse":"styles_navbarCollapse__3VNm0","navbarBrand":"styles_navbarBrand__XDkj4"};